/**
 * Fábrica de chaves de cache por módulo (discovery/06 §3.c). A chave sempre começa pelo módulo, então
 * `invalidateQueries({ queryKey: keys.all })` limpa tudo dele. Quem manda `tenant` na query põe o tenant
 * nos params, para o cache não vazar entre correspondentes.
 */
export function createQueryKeys<const M extends string>(module: M) {
  return {
    all: [module] as const,
    lists: () => [module, 'list'] as const,
    list: <P extends object>(params: P) => [module, 'list', params] as const,
    details: () => [module, 'detail'] as const,
    detail: (id: string) => [module, 'detail', id] as const,
    sub: <P extends object | undefined = undefined>(id: string, name: string, params?: P) =>
      params === undefined ? ([module, 'detail', id, name] as const) : ([module, 'detail', id, name, params] as const),
    custom: <const T extends readonly unknown[]>(...parts: T) => [module, ...parts] as const,
  };
}

export type QueryKeys<M extends string = string> = ReturnType<typeof createQueryKeys<M>>;
